import { Component, OnInit } from '@angular/core';

export interface ReportLink {
  href: string;
  name: string;
  icon: string;
  description: string;
  featured?: boolean;
}

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
  public searchQuery = '';

  public reportLinks: ReportLink[] = [
    { href: 'doctorBusinessSummary', name: 'Doctor Business Summary', icon: 'leaderboard', description: 'Monthly doctor business and completed cases', featured: true },
    { href: 'productUsageSummary', name: 'Product Usage Summary', icon: 'category', description: 'Monthly product usage from completed jobs', featured: true },
    { href: 'salesCommPersonReport', name: 'Sales / Comm Person Report', icon: 'person_pin', description: 'Sales and communication person performance by doctor', featured: true },
    { href: 'pendingJobData', name: 'Pending Job Data', icon: 'pending_actions', description: 'View all pending job orders' },
    { href: 'jobOrderLog', name: 'Job Order Log', icon: 'list_alt', description: 'Complete job order history' },
    { href: 'allDoctors', name: 'All Doctors', icon: 'people', description: 'Doctor directory report' },
    { href: 'productionJobData', name: 'City Wise Production', icon: 'factory', description: 'Production details by city' },
    { href: 'dailyJobActivity', name: 'Daily Order Summary', icon: 'event_note', description: 'Daily order activity report' },
    { href: 'taxInvoice', name: 'Sales Tax Register', icon: 'receipt_long', description: 'Tax invoice register' },
    { href: 'account_ledger', name: 'Account Ledger', icon: 'menu_book', description: 'Detailed account ledger' },
    { href: 'accountAging', name: 'Outstanding Receivables', icon: 'schedule', description: 'Account aging analysis' },
  ];

  constructor() {}

  ngOnInit(): void {}

  get filteredReportLinks(): ReportLink[] {
    if (!this.searchQuery.trim()) {
      return this.reportLinks;
    }
    const query = this.searchQuery.toLowerCase();
    return this.reportLinks.filter(
      (link) =>
        link.name.toLowerCase().includes(query) ||
        link.description.toLowerCase().includes(query)
    );
  }
}
